import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BChip',
  props: {
    chips: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    // This option is used only for the single select chips
    clearable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var filled = ref([]);
    function onClick(chipId) {
      if (!props.multiple) {
        if (props.clearable) {
          filled.value = filled.value.includes(chipId) ? [] : [chipId];
        } else {
          filled.value = [chipId];
        }
        emit('click', filled.value);
        return;
      }
      filled.value = filled.value.includes(chipId) ? filled.value.filter(function (id) {
        return id !== chipId;
      }) : [].concat(_toConsumableArray(filled.value), [chipId]);
      emit('click', filled.value);
    }
    onMounted(function () {
      filled.value = props.chips.filter(function (chip) {
        return chip.selected;
      }).map(function (chip) {
        return chip.id;
      });
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      filled: filled,
      onClick: onClick
    };
  }
});